const $inject = [];

const lbaHelpIcon = function () {
  return {
    restrict: 'A',
    scope: {
      helpText: '<'
    },
    bindToController: true,
    controller: 'lbaHelpIconCtrl',
    controllerAs: 'vm',
    template: require('./lbaHelpIcon.html')
  }
};

lbaHelpIcon.$inject = $inject;

export default lbaHelpIcon; 


// WEBPACK FOOTER //
// ./src/components/lbaHelpIcon/lbaHelpIconDir.js